import { ApiService } from "./api.service";
export default class ServiceReceivingService extends ApiService {
  namespace = "serviceReceiving";
  icon = "PalletizedBoxes";
  name = "Type";
  favicon = "CubeBlue";
  Width = 1400;
  DOMAIN = -52;
  action = "action";
  singular = this.terminology.type.singular;
  plural = this.terminology.type.plural;
  vowel = this.terminology.type.vowel;
  constructor() {
    super("service-receiving");
  }
}
